import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import fileDownload from 'js-file-download';
import {
  getPatientAttachmentsRequest,
  sendInsuranceFileRequest, uploadInsuranceFileRequest,
} from '../../../../../store/actions/patients';
import accountHelpers from '../../../../../utils/accountHelpers';
import AttachedFile from '../../../../_common/AttachedFile/AttachedFile';
import api from '../../../../../api/api';
import { setLoadingProgress } from '../../../../../store/actions/loadingProgess';
import { PatientAndScriptTabHeader } from '../../../../../utils/data/data';

const typeOptions = [
  'Insurance Card',
  'Assignment of Benefits',
  'Patient Agreement Form',
  'Other',
];

let firstLoad = true;

function FilesDocs() {
  const dispatch = useDispatch();
  const { patientAttachments, requestStatus } = useSelector((store) => store.patients);
  const { loadProgress } = useSelector((store) => store.loadingProgress);

  const { patientId } = useParams();

  const [sendFile, setSendFile] = useState({
    fileName: '',
    attachmentFile: null,
    type: '',
    patientId,
    userId: accountHelpers.getUser().id,
    attachedBy: accountHelpers.getUser().username,
  });
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [btnLoad, setBtnLoad] = useState(false);

  useEffect(() => {
    (async () => {
      await dispatch(getPatientAttachmentsRequest({ patientId }));
      firstLoad = false;
    })();
  }, []);

  const onFileClick = async (fileName) => {
    if (loadProgress.status) {
      toast.error('please with finished download file');
      return;
    }

    try {
      dispatch(setLoadingProgress({
        status: 'Download start',
        percent: 0,
      }));

      const { data } = await api.getFile(
        { patientId, userId: accountHelpers.getUser().id, fileName },
        ({ total, loaded }) => {
          const percent = Math.round((loaded * 100) / total);

          dispatch(setLoadingProgress({
            status: 'Loading',
            percent,
          }));
        },
      );

      fileDownload(new Uint8Array(data.Body.data), fileName);

      toast.success('Download completed');
      dispatch(setLoadingProgress({
        status: 'Download completed',
        percent: 0,
      }));

      const timeout = setTimeout(() => {
        dispatch(setLoadingProgress({
          status: '',
          percent: 0,
        }));

        clearTimeout(timeout);
      }, 1000);
    } catch (e) {
      console.warn(e);

      dispatch(setLoadingProgress({
        status: '',
        percent: 0,
      }));

      toast.error(`Unable to retrieving ${fileName}`);
    }
  };

  const onChangeFile = (file) => {
    if (file.type !== 'application/pdf') {
      toast.error('Please upload pdf file');
    } else {
      setSendFile((prev) => ({ ...prev, attachmentFile: file, fileName: file.name }));
    }
  };

  const onCloseModal = () => {
    setSendFile({
      fileName: '',
      attachmentFile: null,
      type: '',
      patientId,
      userId: accountHelpers.getUser().id,
      attachedBy: accountHelpers.getUser().username,
    });

    setIsOpenModal(false);
    setBtnLoad(false);
  };

  const onSaveFile = async () => {
    if (!sendFile.attachmentFile || !sendFile.type || requestStatus === 'request') {
      if (!sendFile.attachmentFile && !sendFile.type) {
        toast.error('Please select file and type');
      } else if (!sendFile.attachmentFile) {
        toast.error('Please select file');
      } else if (!sendFile.type) {
        toast.error('Please select type');
      }

      return;
    }

    setBtnLoad(true);

    const { status } = await dispatch(sendInsuranceFileRequest(sendFile));

    if (status === 'ok') {
      const data = await dispatch(uploadInsuranceFileRequest(sendFile));

      if (data.status === 'ok') {
        toast.success('File uploaded');

        await dispatch(getPatientAttachmentsRequest({ patientId }));

        setBtnLoad(false);
        onCloseModal();
      } else {
        toast.error('File uploaded failed');

        setBtnLoad(false);
      }
    } else {
      toast.error('File uploaded failed');

      setBtnLoad(false);
    }
  };

  return (
    <AttachedFile
      sendFile={sendFile}
      onChangeFile={onChangeFile}
      onCloseModal={onCloseModal}
      onSaveFile={onSaveFile}
      isOpenModal={isOpenModal}
      requestStatus={requestStatus}
      firstLoad={firstLoad}
      attachments={patientAttachments}
      header={PatientAndScriptTabHeader}
      setIsOpenModal={setIsOpenModal}
      onFileClick={onFileClick}
      typeOptions={typeOptions}
      setSendFile={setSendFile}
      btnLoad={btnLoad}
    />
  );
}

export default FilesDocs;
